import { selection, select } from 'd3-selection'
import { transition } from 'd3-transition'

/**
 * Plugs in functions in d3 selection and transition.
 */
export function d3plugin () {
  append()
  attr()
  plugTransition()
  transitionOther()
  other()
}
function append () {
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // div(text?: string): this;
  // #endregion
  selection.prototype.div = function (text) {
    if (text !== undefined) {
      return this.append('div').text(text)
    } else {
      return this.append('div')
    }
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // svg(): this;
  // #endregion
  selection.prototype.svg = function () {
    return this.append('svg')
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // a(): this;
  // #endregion
  selection.prototype.a = function () {
    return this.append('a')
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // g(): this;
  // #endregion
  selection.prototype.g = function () {
    return this.append('g')
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // svgText(): this;
  // #endregion
  selection.prototype.svgText = function () {
    return this.append('text')
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // span(text?: string): this;
  // #endregion
  selection.prototype.span = function (text) {
    if (text !== undefined) {
      return this.append('span').text(text)
    } else {
      return this.append('span')
    }
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // button(text?: string): this;
  // #endregion
  selection.prototype.button = function (text) {
    return this.append('button')
      .clas('btn btn-primary btn-lg')
      .style('margin', '4px')
      .text(text)
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // pagination(): this;
  // #endregion
  selection.prototype.pagination = function () {
    return this.append('ul').clas('pagination justify-content-center')
  }
  // #region Selection 
  // /**
  //  * Appends svg graphical element: text framed by rounded box.\
  //  * This is g element with two children: rect and text
  //  */
  // boxedText(text): this;
  // #endregion
  selection.prototype.boxedText = function (text) {
    /**
     * @type {d3.Selection}
     */
    let g = this.append('g')
      .attr('cursor', 'default')
    g.append('rect')
    g.svgText()
      .text(text)

    g.select('rect')
      .attr('fill', 'white')
      .attr('stroke', '#dee2e6')
      .attr('stroke-width', 1.8)
      .attr('rx', 3)

    g.each((d, i, g) => {
      let text = select(g[i]).select('text')
      let box = text.box()
      text
        .x(8)
        .y(box.height - 2.5)
      select(g[i]).select('rect')
        .width(box.width + 16)
        .height(box.height + 4)
    })

    return g
  }
}
function attr () {
  // #region Selection 
  // /**
  //  * Plugged in
  //  * @param name Class name
  //  */
  // clas(name: string): this;
  // #endregion
  selection.prototype.clas = function (name) {
    return this.attr('class', name)
  }
  // #region Selection 
  // /**
  // * Plugged in
  // * @param name Class name
  // */
  // id(name: string): this;
  // #endregion
  selection.prototype.id = function (name) {
    return this.attr('id', name)
  }
  // #region Selection 
  // /**
  // * Plugged in
  // */
  // cursorPointer(): this;
  // #endregion
  selection.prototype.cursorPointer = function () {
    return this.attr('cursor', 'pointer')
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // x(v): this;
  // #endregion
  selection.prototype.x = function (v) {
    return this.attr('x', v)
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // y(v): this;
  // #endregion
  selection.prototype.y = function (v) {
    return this.attr('y', v)
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // width(v): this;
  // #endregion
  selection.prototype.width = function (v) {
    return this.attr('width', v)
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // height(v): this;
  // #endregion
  selection.prototype.height = function (v) {
    return this.attr('height', v)
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  * Changes width and height attributes.
  //  * If v is function, v is called twice
  //  */
  // wh(v): this;
  // #endregion
  selection.prototype.wh = function (v) {
    if (typeof v === 'function') {
      return this.width((d, i, g) => v(d, i, g)[0])
        .height((d, i, g) => v(d, i, g)[1])
    } else {
      return this.width(v[0])
        .height(v[1])
    }
  }
  // #region Selection 
  // /**
  //  * Plugged in\
  //  * Changes width and height attributes.\
  //  * Changes viewBox so that x start point is in center.\
  //  * If `v` is function, `v` is called twice
  //  */
  // svgCenteredWh(v): this;
  // #endregion
  selection.prototype.svgCenteredWh = function (wh) {
    if (typeof wh === 'function') {
      return this.wh(wh)
        .attr('viewBox', (d, i, g) =>
          (_wh => -_wh[0] / 2 + ' 0 ' + _wh[0] + ' ' + _wh[1])(wh(d, i, g))
        )
    } else {
      return this.wh(wh)
        .attr('viewBox', -wh[0] / 2 + ' 0 ' + wh[0] + ' ' + wh[1])
    }
  }
  // #region Selection 
  // /**
  //  * Plugged in \
  //  * Important: replaces 'transform' property of svg
  //  */
  // transform(v: any): this;
  // #endregion
  selection.prototype.transform = function (v) {
    if (typeof v === 'function') {
      return this.attr('transform', (d, i, g) => v(d, i, g))
    } else {
      return this.attr('transform', v)
    }
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // fill(f): this;
  // #endregion
  selection.prototype.fill = function (v) {
    return this.attr('fill', v)
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // stroke(f): this;
  // #endregion
  selection.prototype.stroke = function (v) {
    return this.attr('stroke', v)
  }
  // #region Selection 
  // /**
  //  * Plugged in \
  //  * Important: replaces 'transform' property of svg \
  //  * Pass function that returns string x,y or constant string x,y 
  //  */
  // translate(v: any): this;
  // #endregion
  selection.prototype.translate = function (v) {
    if (typeof v === 'function') {
      return this.attr('transform', (d, i, g) => 'translate(' + v(d, i, g) + ')')
    } else {
      return this.attr('transform', 'translate(' + v + ')')
    }
  }
  // #region Selection 
  // /**
  //  * Plugged in\
  //  * Important: replaces 'transform' property of svg\
  //  * @param xy Array with two coordinates: [x, y]
  //  */
  // move(xy: number[]): this;
  // /**
  //  * Plugged in\
  //  * Important: replaces 'transform' property of svg\
  //  * @param fxy Function that given (data, index, group) returns\
  //  * array with two coordinates[x, y]
  //  */
  // move(fxy: ValueFn<GElement, Datum, number[]>): this;
  // #endregion
  selection.prototype.move = function (v) {
    if (typeof v === 'function') {
      return this.attr('transform', (d, i, g) => {
        let xy = v(d, i, g)
        return 'translate(' + xy[0] + ',' + xy[1] + ')'
      })
    } else {
      return this.attr('transform', 'translate(' + v[0] + ',' + v[1] + ')')
    }
  }
}
function plugTransition () {
  // #region Transition 
  // /**
  //  * Plugged in
  //  * Important: replaces 'transform' property
  //  * Pass function that returns string x,y or constant of string x,y 
  //  * @param name Class name
  //  */
  // translate(name: any): this;
  // #endregion
  transition.prototype.translate = function (v) {
    if (typeof v === 'function') {
      return this.attr('transform', (d, i, g) => 'translate(' + v(d, i, g) + ')')
    } else {
      return this.attr('transform', 'translate(' + v + ')')
    }
  }
  // #region Transition 
  // /**
  //  * Plugged in \
  //  * Important: replaces 'transform' property of svg \
  //  * @param xy Array with two coordinates: [x, y]
  //  */
  // move(xy: number[]): this;
  // /**
  //  * Plugged in \
  //  * Important: replaces 'transform' property of svg \
  //  * @param fxy Function that given (data, index, group) returns \
  //  * array with two coordinates[x, y]
  //  */
  // move(fxy: ValueFn<GElement, Datum, number[]>): this;
  // #endregion
  transition.prototype.move = function (v) {
    if (typeof v === 'function') {
      return this.attr('transform', (d, i, g) => {
        let xy = v(d, i, g)
        return 'translate(' + xy[0] + ',' + xy[1] + ')'
      })
    } else {
      return this.attr('transform', 'translate(' + v[0] + ',' + v[1] + ')')
    }
  }
  // #region Transition 
  // /**
  //  * Plugged in
  //  */
  // width(v): this;
  // #endregion
  transition.prototype.width = function (v) {
    return this.attr('width', v)
  }
  // #region Transition 
  // /**
  //  * Plugged in
  //  */
  // height(v): this;
  // #endregion
  transition.prototype.height = function (v) {
    return this.attr('height', v)
  }
  // #region Transition 
  // /**
  //  * Plugged in
  //  * Changes width and height attributes.
  //  * If v is function, v is called twice
  //  */
  // wh(v): this;
  // #endregion
  transition.prototype.wh = function (v) {
    if (typeof v === 'function') {
      return this.width((d, i, g) => v(d, i, g)[0])
        .height((d, i, g) => v(d, i, g)[1])
    } else {
      return this.width(v[0])
        .height(v[1])
    }
  }
  // #region Transition 
  // /**
  //  * Plugged in
  //  */
  // fill(v): this;
  // #endregion
  transition.prototype.fill = function (v) {
    return this.attr('fill', v)
  }
  // #region Transition 
  // /**
  //  * Plugged in
  //  */
  // stroke(v): this;
  // #endregion
  transition.prototype.stroke = function (v) {
    return this.attr('stroke', v)
  }

}
function transitionOther () {
  // #region Transition 
  // /**
  // * Plugged in\
  // * Calls function f for each node of selection\
  // * Passes node and datum to f
  // */
  // all(f: (node: Selection<EnterElement, any, null, undefined>, data: Datum) => void): this;
  // #endregion
  transition.prototype.all = function (f) {
    return this.each((d, i, g) => f(select(g[i]), d))
  }
}
function other () {
  // #region Selection
  // /**
  //  * Plugged in
  //  */
  // fillIn(f): this;
  // #endregion
  selection.prototype.fillIn = function (texts) {
    this.html(null)
    for (let i = 0; i < texts.length; ++i) {
      this.append('li').clas('page-item')
        .append('a')
        .clas('page-link')
        .text(texts[i])
    }
    return this
  }
  // #region Selection 
  // /**
  //  * Plugged in
  //  */
  // box(): {x: number, y: number, width: number, height: number};
  // #endregion
  selection.prototype.box = function () {
    return this.node().getBBox()
  }
  // #region Selection 
  // /**
  // * Plugged in
  // */
  // grid(nColumns?: number): this;
  // #endregion
  selection.prototype.grid = function (nColumns) {
    if (nColumns !== undefined) {
      return this.append('div')
        .style('display', 'grid')
        .style('grid-template-columns', 'repeat(' + nColumns + ', 1fr)')
    } else {
      return this.append('div').style('display', 'grid')
    }
  }
  // #region Selection 
  // /**
  // * Plugged in
  // */
  // clear(): this;
  // #endregion
  selection.prototype.clear = function () {
    return this.html(null)
  }
  // #region Selection 
  // /**
  // * Plugged in
  // */
  // onclick(f: ValueFn<GElement, Datum, void>): this;
  // #endregion
  selection.prototype.onclick = function (f) {
    return this.on('click', f)
  }
  // #region Selection 
  // /**
  // * Plugged in
  // */
  // onmouseenter(f: ValueFn<GElement, Datum, void>): this;
  // #endregion
  selection.prototype.onmouseenter = function (f) {
    return this.on('mouseenter', f)
  }
  // #region Selection 
  // /**
  // * Plugged in
  // */
  // onmouseleave(f: ValueFn<GElement, Datum, void>): this;
  // #endregion
  selection.prototype.onmouseleave = function (f) {
    return this.on('mouseleave', f)
  }
  // #region Selection 
  // /**
  // * Plugged in\
  // * Calls function f for each node of selection\
  // * Passes node and datum to f
  // */
  // all(f: (node: Selection<EnterElement, any, null, undefined>, data: Datum) => void): this;
  // #endregion
  selection.prototype.all = function (f) {
    return this.each((d, i, g) => f(select(g[i]), d))
  }
}